import React, { MouseEventHandler, useCallback, useContext } from 'react'
import styled from 'styled-components'

import { ItemCardVariant } from '../ItemCard'

import { tripBookingDetailsButtonClicked } from 'analytics/eventDefinitions'
import { fireInteractionEvent } from 'api/googleTagManager'
import TextButton from 'components/Luxkit/Button/TextButton'
import { mediaQueryDown, mediaQueryOnly } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { BOOKING_DETAILS_COPY } from 'tripPlanner/config'
import TripContext from 'tripPlanner/contexts/TripContext'
import LEBookingTag from 'tripPlanner/Tripkit/Common/LEBookingTag'

const BookingDetailsContainer = styled(Group)`
  ${mediaQueryDown.mobile} {
    > * {
      flex-grow: 1;
    }
  }

  ${mediaQueryOnly.desktop} {
    > * {
      flex-grow: 1;
    }
  }
`

interface Props {
  onClick: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>
  variant: ItemCardVariant
}

export default function BookingDetailsButtonAndTagView({
  variant,
  onClick,
}: Props) {
  const tripContext = useContext(TripContext)
  const canEdit = tripContext?.permissions.canEdit ?? false
  const viewAsTemplate = tripContext?.viewAsTemplate ?? false
  const onButtonClick = useCallback<
    MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>
  >(
    (event) => {
      const source =
        variant === 'drawer' ? 'trip_drawer_all_saved_items' : 'trip_summary'
      fireInteractionEvent(tripBookingDetailsButtonClicked(source))
      onClick(event)
    },
    [variant, onClick],
  )

  if (!canEdit || viewAsTemplate) return null

  return (
    <BookingDetailsContainer
      direction="vertical"
      tabletDirection="horizontal"
      gap={12}
      horizontalAlign="space-between"
    >
      <LEBookingTag />
      <TextButton kind="secondary" onClick={onButtonClick}>
        {BOOKING_DETAILS_COPY}
      </TextButton>
    </BookingDetailsContainer>
  )
}
